import { useContext } from "react";
import { Picker, Selector } from "../../../sharable/PickerAndSelector";
import { COLORS } from "../../CanvasViewer/EncarteConstants";
import {
  FontSizeSlider,
  FontSizeSliderWrapper,
  SelectProductMessage,
  TextStyles,
} from "./StylesMenuView.styles";
import WorkspaceContext from "../../WorkspaceContext";
import {
  isCartazFormat,
  themeHasDefaultStyles,
} from "../../../../services/Utils";
import { CARTAZ_FONTS, ENCARTE_FONT_FAMILIES } from "./useFormatFontFamily";

export default function TextStylesWrapper({
  styles,
  selectedProduct,
  updateProductStyle,
  onStylesChange,
  productStyles,
}) {
  const { model } = useContext(WorkspaceContext);

  const fontFamilies = isCartazFormat(styles.format)
    ? CARTAZ_FONTS
    : ENCARTE_FONT_FAMILIES;
  return (
    <TextStyles>
      {model.hasDefaultStyles && (
        <SelectProductMessage className="product-selection-message">
          O tema escolhido ainda não possui estilos pré-definidos. Escolha os
          estilos globais ou selecione um produto para customizar os estilos
          individualmente.
        </SelectProductMessage>
      )}
      <h2>Texto</h2>

      {!selectedProduct && (
        <Selector
          options={fontFamilies}
          txt="Estilo da fonte"
          callback={(c) => {
            onStylesChange("fontFamily", c);
          }}
          selected={styles.fontFamily}
        />
      )}

      {!selectedProduct && !model.hasDefaultStyles && (
        <SelectProductMessage className="product-selection-message">
          Selecione um produto para mais opções de estilo
        </SelectProductMessage>
      )}
      {(selectedProduct || model.hasDefaultStyles) && (
        <>
          <FontSizeSliderWrapper className="flex direction-column">
            <label htmlFor="font-size-slider">
              Tamanho da fonte:{" "}
              <strong>{Math.floor(productStyles.fontSize)}</strong>
            </label>
            <FontSizeSlider
              id="font-size-slider"
              type="range"
              min={18}
              max={100}
              value={productStyles.fontSize}
              onChange={(e) => updateProductStyle("fontSize", e.target.value)}
            />
          </FontSizeSliderWrapper>
          <Picker
            color={productStyles.txtColor}
            txt="Cor do nome do produto"
            colorsArr={COLORS}
            callback={(c) => {
              updateProductStyle("txtColor", c);
            }}
            defaultColor="#fff"
          />
          <Picker
            color={productStyles.bgColor}
            txt="Cor de fundo do produto"
            colorsArr={COLORS}
            callback={(c) => {
              updateProductStyle("bgColor", c);
            }}
            defaultColor="#000000"
            alphaPicker={true}
          />
          <Picker
            color={productStyles.priceTxtColor}
            txt="cor do preço"
            colorsArr={COLORS}
            callback={(c) => {
              updateProductStyle("priceTxtColor", c);
            }}
            optional={false}
            defaultColor="#fff"
          />
        </>
      )}
    </TextStyles>
  );
}
